export interface ErrorPayload {
  code: string
  message: string
  extraInformation?: string
}

export interface SuccessPayload<T> {
  data: T
}

export function isErrorPayload(payload: any): payload is ErrorPayload {
  return typeof payload === "object" && payload !== null && "code" in payload
}

export type ApiResponsePayload<T> = SuccessPayload<T> | ErrorPayload

export type ApiWrapper<T> = {
  success: boolean
  error: unknown
  payload: T
}
